import { toast } from 'react-toastify'

export const toastifyConfig = {
  position: toast.POSITION.TOP_CENTER,
  autoClose: 3000,
  toastId: Math.random() * 10,
}
